import { Component, Vue } from 'vue-facing-decorator';;
import { ElMessage, ElMessageBox } from 'element-plus';
import { Check, CircleClose  } from '@element-plus/icons-vue';
import Status from "@/models/EnumStatus";
import Header from '@/components/Header/Header.vue';
import Navigation from '@/components/Navigation/Navigation.vue';
import NavigationIndex from "@/models/EnumNavigationIndex";
import Breadcrumbs from '@/components/Breadcrumbs/Breadcrumbs.vue';
import AuthService from '@/services/AuthService';
import ApiService from '@/services/ApiService';
import WebSocketService from '@/services/WebSocketService';

@Component(
{
    components:
    {
        Header,
        Breadcrumbs,
        Navigation,
        Check,
        CircleClose
    },
    enums:
    {
        Status,
        NavigationIndex
    }
})

export default class QuestionnaireDone extends Vue 
{
    private loading : boolean = true;
    private loadingParticipants : boolean = true;
    private hasPermission: boolean[] = [] as boolean[];
    private testId : number = 0;
    private testName : string = '';
    private testDate : Date = new Date();
    private targetgroupNames : string = '';
    private participantList : ParticipantModel[] | undefined = [];
    private testModel : TestModel | undefined = {} as TestModel;
    private step : number = 1;
    private substep : number  = 1;
    
    public async mounted()
    {
        // get permissions
        await AuthService.getPermissions();
        this.hasPermission['TEST_SELECT'] = AuthService.hasPermission('TEST_SELECT');
        this.hasPermission['TEST_INSERT'] = AuthService.hasPermission('TEST_INSERT');
        this.hasPermission['TEST_UPDATE'] = AuthService.hasPermission('TEST_UPDATE');
        this.hasPermission['TEST_DELETE'] = AuthService.hasPermission('TEST_DELETE');
        
        if (this.hasPermission['TEST_UPDATE'])
        {
            // get test id from get request
            this.testId = this.$route.params.testid as string;

            // get step from params
            this.step = parseInt(this.$route.params.step) as number;

            // get substep from params
            this.substep = parseInt(this.$route.params.substep) as number;

            // load test from db
            this.testModel = await ApiService.getTest(this.testId);
            
            if (!this.testModel) 
            {
                this.$router.push('/test');
                return;
            }
            else
            {
                this.testName = this.testModel.name;
                this.testDate = this.testModel.testdate;
            }

            await this.loadParticipants();
        }

        window.addEventListener('resize', this.onWindowResize);

        this.loading = false;
    }

    private beforeUnmount()
    {
        window.removeEventListener('resize', this.onWindowResize);
    }

	private onWindowResize(e : any)
    {
        this.windowWidth = window.innerWidth;
        this.windowHeight = window.innerHeight;
    }

    private async loadParticipants()
    {
        this.loadingParticipants = true;
        this.participantList = await ApiService.getActiveParticipantsForTest(this.testModel.testid.toString());

		for (let p : ParticipantModel of this.participantList)
        {
            p.remainingMinutes = (this.testModel.timelimit - (new Intl.DateTimeFormat('de-DE', {minute: '2-digit'}).format((new Date().getTime()) - (new Date(0).setUTCSeconds(p.datestart))))) + p.extratime;
            if (p.remainingMinutes <= 0 || !p.datestart) p.remainingMinutes = 0;
        }
        this.loadingParticipants = false;
    }

    public onReturnClick()
    {
        this.$router.push(`/test/${this.testModel.testid.toString()}`);
    }
}
